import { motion } from 'motion/react'

import { cn } from '@/lib/utils'

type AnnotationProps = {
  label: string
  position: string
  align: 'left' | 'right'
}

export default function Annotation({ label, position, align }: AnnotationProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute hidden w-fit items-center gap-2 lg:flex',
        position,
        align === 'right' ? 'flex-row-reverse' : 'flex-row',
      )}
    >
      <motion.div
        initial={{ opacity: 0, x: align === 'right' ? -20 : 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="pb-px text-13 leading-none text-zinc-400"
      >
        {label}
      </motion.div>

      <div className="relative w-16">
        <motion.div
          initial={{ opacity: 0, width: 0 }}
          whileInView={{ opacity: 1, width: 64 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className={cn(
            'absolute h-px w-16 shrink-0 -translate-y-1/2 border-[0.5px] border-dashed border-white/20',
            align === 'right' ? 'right-0' : 'left-0',
          )}
        ></motion.div>
      </div>

      <div className="relative h-1.5 w-1.5 shrink-0">
        <div className="absolute h-full w-full rounded-full bg-primary-500"></div>
        <div className="absolute -left-[3px] -top-[3px] h-3 w-3 animate-ping rounded-full bg-primary-500 opacity-50"></div>
      </div>
    </div>
  )
}
